import { handleApiRequest } from '../services/transports';

import { REACT_APP_RSD_DOMAIN } from './base';

export const postEstablishment = data => handleApiRequest({ path: `
${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-scn-company`,
method: 'post',
data
});

export const updateEstablishment = data => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Register/mp-sce-company`,
  method: 'put',
  data
});


export const searchEstablishments = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Company/company-list`,
  method: 'get',
  query
});

export const searchEstablishmentsDropdown = query => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Company/comapny-by-username`,
  method: 'get',
  query
});
export const searchEstablishmentsByGTINDropdown = gtin => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Company/sop-comapny-by-gtin/${gtin}`,
  method: 'get'
});

export const searchEstablishmentById = (id, query) => handleApiRequest({
  path: `${REACT_APP_RSD_DOMAIN}user-service/api/portal/Company/${id}`,
  method: 'get',
  query
});

